<template>
    <div v-show="show" class="iframe-container" :style="containerStyle">
        <iframe ref="iframeContent" class="content" :src="iframeSrc" frameborder="0" referrerpolicy="unsafe-url" allow=""></iframe>
        <div class="buttons close-btns" @click="handleClose">
            <div class="left"></div>
            <div class="right"></div>
        </div>
    </div>
</template>

<script>
import { settingStore } from "../js/store/settingStore";
import { store } from "../store";
import AppRenderer from "../js/app_renderer";
export default {
    name: "IframeContainer",
    data() {
        return {
            show: false,
            iframeSrc: "",
            iframeContent: null,

            settingStore,
            store,
        };
    },
    methods: {
        openUrl(url) {
            // 影片分段
            if (url.includes("movie_segmentation")) {
                AppRenderer.Instance.openWebPageInSubWindow(url);
                return;
            }

            this.show = true;
            this.iframeSrc = url;
            store.setIframeDisabledTools();
        },
        handleClose() {
            this.show = false;
            this.iframeSrc = "www.aaaaaaa.com";
            store.clearDisabledTools();
        },
    },
    computed: {
        pageHeight() {
            return window.innerHeight - store.toolbarHeight;
        },
        containerStyle() {
            return {
                width: store.pageWidth + "px",
                height: store.globalPaintData.height + "px",
                left: "0px",
            };
        },
    },
    mounted() {
        this.iframeContent = this.$refs.iframeContent;
    },
};
</script>

<style scoped>
.iframe-container {
    position: absolute;
    z-index: var(--z-index-iframe);
}

.content {
    width: 100%;
    height: 100%;
}

.close-btns div {
    position: absolute;
    background-image: url("../assets/afile/close.png");
    background-size: contain;
    width: 3.8vh;
    height: 3.8vh;
    min-width: 36px;
    min-height: 36px;
    bottom: 3px;
}

.close-btns div.left {
    left: 3px;
}

.close-btns div.right {
    right: 3px;
}
</style>
